<div class="w-full max-w-3xl mx-auto">
  @if (!currentUser()) {
    <korviu-loader />
  } @else if (showEmptyPage()) {
    <app-empty />
  } @else {
    <app-dashboard />
  }
</div>
